import React from 'react';
const Button = React.lazy(() => import('@material-ui/core/Button'));
const Grid = React.lazy(() => import('@material-ui/core/Grid'));
import {StandartInput} from '@components/form/StandartInput';
const RemoteAutocompleteSelect = React.lazy(() => import('@components/form/RemoteAutocompleteSelect'));
const RemoteAutocompleteWithSearch = React.lazy(() => import('@components/form/RemoteAutocompleteWithSearch'));
const ResponsiveComponent = React.lazy(() => import('@components/form/ResponsiveComponent'));
import {NewCharacteristicContainer} from '@components/characteristics/modals/new-characteristic/new-characteristic.container';
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import {SimpleDialog} from "@components/form/SimpleDialog";
import {LabelButton} from "@components/common/buttons/LabelButton";
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded";
import clsx from "clsx";
import {PricesTableComponent} from "@components/product/modals/new-product/components/prices-table.component";
import {ProductPricesContainer} from "@components/product/modals/new-product/product-prices.container";
import {TooltipButton} from "@components/common/buttons/TooltipButton";
import FormLabel from "@material-ui/core/FormLabel";

const merge = require('deepmerge');

export class ProductVariationComponent extends React.Component {
    initState = {
        form: {
            id: "",
            characteristic_id: "",
            sku: "",
            barcode: "",
            price: "",
            price_in: "",
            prices: [],
            status: true,
            main_supplier_id: "",
        },
        characteristic: null,
        searchString: '',
        errors: {}
    };
    state = {
        open: false,
        ...this.initState
    };

    componentDidUpdate(prevState, prevProps) {
        if (this.props.variationId && this.state.open && this.state.open != prevProps.open) {
            this.setState({form: {...this.state.form, ...this.props.data}});
        } else if (this.state.open != prevProps.open) {
            this.setState(this.initState)
        }
    }

    handlePriceGroupSubmit = (data, priceGroupId = undefined) => {
        let {form: {prices}} = this.state;

        if (data.id) {
            prices = prices.map(group => {
                if (group.id === data.id)
                    group = data;
                return group;
            })
        } else if (!priceGroupId && data.group_id) {
        let found = false;
        prices = prices.map(group => {
                if (group.group_id === data.group_id) {
                    group = data;
                    found = true;
                }
                return group;
            });
        if (!found) {
                prices.push(data);
            }
        } else prices.push(data);

        this.setState({
            form: {...this.state.form, prices: [...prices]}
        });
    }

    handleSubmit = () => {
        let errors = {};
        if (isNaN(parseInt(this.state.form.characteristic_id))) {
            errors.characteristic_id = ['Выберите признак характеристики'];
        }
        if (parseFloat(this.state.form.price) <= 0 || isNaN(parseFloat(this.state.form.price))) {
            errors.price = ['Укажите розничную цену'];
        }
        if (("" + this.state.form.sku).length <= 0) {
            errors.sku = ['Укажите SKU товара'];
        }
        if (Object.keys(errors).length > 0) {
            this.setState({errors});
            return;
        }

        let { onSubmit } = this.props;
        onSubmit(this.state.form, this.props.variationId);
        this.setState({open: false, ...this.initState});
    };

    input = ({name, label}) => <StandartInput
        name={name}
        value={this.state.form[name]}
        errors={this.state.errors}
        className={this.props.classes.input}
        label={label}
        size={'small'}
        margin={'normal'}
        variant={'outlined'}
        fullWidth
        onChange={({target: {value}}) => this.setState(merge(this.state, {form: {[name]: value}}))}
    />;

    onCharacteristicCreate = (characteristic) => {
        this.setState({
            ...this.state,
            characteristic: {value: characteristic.id, label: characteristic.name},
            form: {...this.state.form, characteristic_id: characteristic.id}
        })
    };

    render() {
        let { classes, children } = this.props;
        return (
            <SimpleDialog
                fullWidth={true}
                maxWidth={'sm'}
                open={this.state.open}
                onClose={(e) => this.setState({open: false})}
                title={ this.props.variationId
                    ? <ResponsiveComponent xs='Редактирование вариации' sm='Редактирование существующей вариации товара'/>
                    : <ResponsiveComponent xs='Добавление вариации' sm='Добавление новой вариации товара'/> }
                icon={ this.props.variationId
                    ? (<TooltipButton title="Редактировать"
                        icon={<EditOutlinedIcon />}
                        onClick={(e) => this.setState({open: true})}
                    />)
                    : children
                        ? (<span
                                onClick={(e) => this.setState({open: true})}
                            >
                            {children}
                        </span>)
                        : <LabelButton
                            title={'Создать вариацию товара'}
                            icon={<AddCircleRoundedIcon color={'primary'}/>}
                            onClick={(e) => this.setState({open: true})}
                            disableMarginBottom
                        />
                }
                actions={[
                    (<Button
                        onClick={(e) => this.handleSubmit()}
                        color="primary" variant="contained"
                    >
                        Сохранить
                    </Button>),
                ]}
            >
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12}>
                        <div className={classes.inputWithIconButton}>
                            <RemoteAutocompleteWithSearch
                                name={'characteristic_id'}
                                url={'/api/v1/characteristics/autocomplete'}
                                SearchString={this.state.searchString}
                                value={this.state.form.characteristic_id}
                                errors={this.state.errors}
                                label={<ResponsiveComponent xs='Вариация' sm='Признак характеристики (вариация) продукта'/>}
                                onChange={(e, {value}) => this.setState(merge(this.state, {form: {characteristic_id: value}}))}
                                disableClearable={true}
                                key={this.state.characteristic_id}
                                groupBy={(option) => option.group.name}
                                className={clsx([
                                    classes.input,
                                    classes.resetInputMarginTop,
                                ])}
                                size={'small'}
                                margin={'normal'}
                                variant={'outlined'}
                                fullWidth
                                objectValue={this.state.characteristic}
                            />
                            <NewCharacteristicContainer
                                customOpenButton={<AddCircleRoundedIcon
                                    className={classes.input_icon}
                                    style={{paddingBottom: '8px', paddingTop: '5px', marginTop: 0}}
                                    color={'primary'}
                                />}
                                onSubmitRedirect={this.onCharacteristicCreate}
                            />
                        </div>

                        <Grid container spacing={3} className={classes.gridSubContainer}>
                            <Grid item xs={12} md={6}>
                                {this.input({name: 'sku', label: 'SKU'})}
                            </Grid>
                            <Grid item xs={12} md={6}>
                                {this.input({name: 'barcode', label: 'Штрих-код'})}
                            </Grid>
                        </Grid>

                        <Grid container spacing={3} className={classes.gridSubContainer}>
                            <Grid item xs={12} md={6}>
                                {this.input({name: 'price', label: 'Розничная цена'})}
                            </Grid>
                            <Grid item xs={12} md={6}>
                                {this.input({name: 'price_in', label: 'Цена прихода'})}
                            </Grid>
                        </Grid>

                        {this.state.form.prices.length > 0
                            ? <>
                                <FormLabel className={clsx([classes.formLabel, classes.formLabel_marginTop])} component="legend">Группы цен</FormLabel>
                                <div className={classes.tableWrapper}>
                                    <PricesTableComponent
                                        groups={this.props.price_groups}
                                        prices={this.state.form.prices}
                                        onSubmit={this.handlePriceGroupSubmit}
                                    />
                                </div>
                            </>
                            : null
                        }

                        <ProductPricesContainer
                            price_groups={this.props.price_groups}
                            onSubmit={this.handlePriceGroupSubmit}
                        />

                        {/*<FormControlLabel*/}
                        {/*    control={<Switch*/}
                        {/*        checked={!!this.state.form.status}*/}
                        {/*        onChange={({target: {value}}) => this.setState(*/}
                        {/*            merge(this.state,{form: {status: !this.state.form.status}})*/}
                        {/*        )}*/}
                        {/*    />}*/}
                        {/*    label="Вариация активна"*/}
                        {/*/>*/}

                        <RemoteAutocompleteSelect
                            name={'main_supplier_id'}
                            url={'/api/v1/suppliers/autocomplete'}
                            value={this.state.form.main_supplier_id}
                            errors={this.state.errors}
                            label="Основной поставщик"
                            onChange={(e, {value}) => this.setState(merge(this.state, {form: {main_supplier_id: value}}))}
                            disableClearable={true}
                            className={clsx([
                                classes.input,
                                classes.resetMarginBottom,
                            ])}
                            size={'small'}
                            margin={'normal'}
                            variant={'outlined'}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </SimpleDialog>
        );
    }
}
